import { useMemo } from 'react';

import { isNotEmpty } from '@/helpers/validators';
import { FormFieldType } from '@/models/customizationModels';
import { useAppSelector } from '@/redux/hooks';

const getFormFieldType = (type: string) => {
  switch (type) {
    case 'string':
      return FormFieldType.INPUT;
    case 'date':
      return FormFieldType.DATE;
    case 'boolean':
      return FormFieldType.BOOLEAN;
    default:
      return FormFieldType.INPUT;
  }
};

export default function useCustomFormFields() {
  const company = useAppSelector((state) => state.auth.companyAccount);

  return useMemo(
    () => [
      {
        showFieldKey: 'form_custom1_checked',
        fieldPositionKey: 'form_custom1_position',
        fieldType: getFormFieldType(company?.custom1_type || ''),
        fieldName: 'custom1',
        fieldLabelKey: 'form_custom1_label',
        fieldLabelValue: 'Custom 1',
        isFieldRequiredKey: 'form_custom1_required',
        fieldErrorMsgKey: 'custom1',
        validator: (value: any, isRequired: boolean) => !isRequired || isNotEmpty(value),
      },
      {
        showFieldKey: 'form_custom2_checked',
        fieldPositionKey: 'form_custom2_position',
        fieldType: getFormFieldType(company?.custom2_type || ''),
        fieldName: 'custom2',
        fieldLabelKey: 'form_custom2_label',
        fieldLabelValue: 'Custom 2',
        isFieldRequiredKey: 'form_custom2_required',
        fieldErrorMsgKey: 'custom2',
        validator: (value: any, isRequired: boolean) => !isRequired || isNotEmpty(value),
      },
      {
        showFieldKey: 'form_custom3_checked',
        fieldPositionKey: 'form_custom3_position',
        fieldType: getFormFieldType(company?.custom3_type || ''),
        fieldName: 'custom3',
        fieldLabelKey: 'form_custom3_label',
        fieldLabelValue: 'Custom 3',
        isFieldRequiredKey: 'form_custom3_required',
        fieldErrorMsgKey: 'custom3',
        validator: (value: any, isRequired: boolean) => !isRequired || isNotEmpty(value),
      },
      {
        showFieldKey: 'form_custom4_checked',
        fieldPositionKey: 'form_custom4_position',
        fieldType: getFormFieldType(company?.custom4_type || ''),
        fieldName: 'custom4',
        fieldLabelKey: 'form_custom4_label',
        fieldLabelValue: 'Custom 4',
        isFieldRequiredKey: 'form_custom4_required',
        fieldErrorMsgKey: 'custom4',
        validator: (value: any, isRequired: boolean) => !isRequired || isNotEmpty(value),
      },
      {
        showFieldKey: 'form_custom5_checked',
        fieldPositionKey: 'form_custom5_position',
        fieldType: getFormFieldType(company?.custom5_type || ''),
        fieldName: 'custom5',
        fieldLabelKey: 'form_custom5_label',
        fieldLabelValue: 'Custom 5',
        isFieldRequiredKey: 'form_custom5_required',
        fieldErrorMsgKey: 'custom5',
        validator: isNotEmpty,
      },
      {
        showFieldKey: 'form_custom6_checked',
        fieldPositionKey: 'form_custom6_position',
        fieldType: getFormFieldType(company?.custom6_type || ''),
        fieldName: 'custom6',
        fieldLabelKey: 'form_custom6_label',
        fieldLabelValue: 'Custom 6',
        isFieldRequiredKey: 'form_custom6_required',
        fieldErrorMsgKey: 'custom6',
        validator: (value: any, isRequired: boolean) => !isRequired || isNotEmpty(value),
      },
      {
        showFieldKey: 'form_custom7_checked',
        fieldPositionKey: 'form_custom7_position',
        fieldType: getFormFieldType(company?.custom7_type || ''),
        fieldName: 'custom7',
        fieldLabelKey: 'form_custom7_label',
        fieldLabelValue: 'Custom 7',
        isFieldRequiredKey: 'form_custom7_required',
        fieldErrorMsgKey: 'custom7',
        validator: (value: any, isRequired: boolean) => !isRequired || isNotEmpty(value),
      },
      {
        showFieldKey: 'form_custom8_checked',
        fieldPositionKey: 'form_custom8_position',
        fieldType: getFormFieldType(company?.custom8_type || ''),
        fieldName: 'custom8',
        fieldLabelKey: 'form_custom8_label',
        fieldLabelValue: 'Custom 8',
        isFieldRequiredKey: 'form_custom8_required',
        fieldErrorMsgKey: 'custom8',
        validator: (value: any, isRequired: boolean) => !isRequired || isNotEmpty(value),
      },
      {
        showFieldKey: 'form_custom9_checked',
        fieldPositionKey: 'form_custom9_position',
        fieldType: getFormFieldType(company?.custom9_type || ''),
        fieldName: 'custom9',
        fieldLabelKey: 'form_custom9_label',
        fieldLabelValue: 'Custom 9',
        isFieldRequiredKey: 'form_custom9_required',
        fieldErrorMsgKey: 'custom9',
        validator: (value: any, isRequired: boolean) => !isRequired || isNotEmpty(value),
      },
      {
        showFieldKey: 'form_custom10_checked',
        fieldPositionKey: 'form_custom10_position',
        fieldType: getFormFieldType(company?.custom10_type || ''),
        fieldName: 'custom10',
        fieldLabelKey: 'form_custom10_label',
        fieldLabelValue: 'Custom 10',
        isFieldRequiredKey: 'form_custom10_required',
        fieldErrorMsgKey: 'custom10',
        validator: (value: any, isRequired: boolean) => !isRequired || isNotEmpty(value),
      },
    ],
    [
      company?.custom10_type,
      company?.custom1_type,
      company?.custom2_type,
      company?.custom3_type,
      company?.custom4_type,
      company?.custom5_type,
      company?.custom6_type,
      company?.custom7_type,
      company?.custom8_type,
      company?.custom9_type,
    ],
  );
}
